import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import {getUserAuthTokenVerified} from "./user"
import {LoginActionTypes} from 'store/types/login'
import {Notify} from 'components/Notification'
import store from '../../../config/store'
import {changeRoute} from "store/actions/login"
import {API_URL} from '../services/config/index'

enum StatusCode {
    Unauthorized = 401,
    Forbidden = 403,
    TooManyRequests = 429,
    InternalServerError = 500,
}


const headers: Readonly<Record<string, string | boolean>> = {
    Accept: "application/json",
    auth_token: '',
    'Accept-Language': localStorage.getItem('preferredLanguage') === "en" ? 'en_EN' : (localStorage.getItem('preferredLanguage') === "ru" ? 'ru_RU' : 'az_AZ'),
  };
  

// We can use the following function to inject the JWT token through an interceptor
// We get the `accessToken` from the localStorage that we set when we authenticate
const injectToken = (config: AxiosRequestConfig): AxiosRequestConfig => {
    try {

        const auth_token=getUserAuthTokenVerified();
        if (auth_token != null) {
           config.headers.auth_token  = `${auth_token}`;
        }

        return config;
    } catch (error) {
        throw new Error(error);
    }
};



export class Http {
    private instance: AxiosInstance | null = null;
    private lang : string;
    constructor(lang?: string) {
        if (lang !== undefined) {
            this.lang = lang;
        }
    }
    private get http(): AxiosInstance {
        return this.instance != null ? this.instance : this.initHttp();
    }

    changeLang = (config: AxiosRequestConfig): AxiosRequestConfig => {
        try {

            if (this.lang !== null && this.lang !== undefined && this.lang !== "") {
                let lang
                if(this.lang === 'en' || this.lang === "EN"){
                    lang = 'en_EN'
                }else if(this.lang === 'ru' || this.lang === "RU"){
                    lang = 'ru_RU'
                }else{
                    lang = 'az_AZ'
                }
               // let lang = this.lang === "en" || "EN" ? 'en_EN' : (this.lang === "ru" || "RU" ? 'ru_RU' : 'az_AZ')

                config.headers['Accept-Language'] = lang;
            }
            return config;
        } catch (error) {
            throw new Error(error);
        }
    };

    initHttp() {
        const http = axios.create({
            baseURL: API_URL,
            headers : headers,
            withCredentials: false,
        });

        http.interceptors.request.use(injectToken, (error) => Promise.reject(error));
        http.interceptors.request.use(this.changeLang, (error) => Promise.reject(error));
        http.interceptors.response.use(
            (response) => response,
            (error) => {
                const { response } = error;
                return this.handleError(response);
            }
        );

        this.instance = http;
        return http;
    }

    request<T = any, R = AxiosResponse<T>>(config: AxiosRequestConfig): Promise<R> {
        return this.http.request(config);
    }

    get<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
        return this.http.get<T, R>(url, config);
    }

    post<T = any, R = AxiosResponse<T>>(
        url: string,
        data?: T,
        config?: AxiosRequestConfig
    ): Promise<R> {
        return this.http.post<T, R>(url, data, config);
    }

    put<T = any, R = AxiosResponse<T>>(
        url: string,
        data?: T,
        config?: AxiosRequestConfig
    ): Promise<R> {
        return this.http.put<T, R>(url, data, config);
    }

    delete<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
        return this.http.delete<T, R>(url, config);
    }

    // Handle global app errors
    // We can handle generic app errors depending on the status code
    private handleError(error) {
        // console.log('................................', error, error.status)

        const { status } = error;
        // console.log('................................ sttaus', error, error.data.messages[0].MESSAGE)

        switch (status) {
            case StatusCode.InternalServerError: {
                const requestUrl = String(error?.config?.url || "");
                const apiMessage = String(
                    error?.data?.messages?.[0]?.MESSAGE ||
                    error?.data?.messages?.[0]?.message ||
                    ""
                );
                const isDgkSearchUnavailable =
                    (requestUrl.includes("brdgk/getInfoByGbNo") || requestUrl.includes("brdgk/getAdvance")) &&
                    /DGK/i.test(apiMessage) &&
                    /Ödəniş şərti|Digər|Payment terms|Other|Условие оплаты|Другое/i.test(apiMessage);
                if (!isDgkSearchUnavailable) {
                    if(error.data && error.data.messages) {
                        Notify( error.data.messages[0].MESSAGE)
                    } else {
                        Notify(error.data)
                    }
                }
                break;
            }
            case StatusCode.Forbidden: {
                // Handle Forbidden
                if(error.data.messages[0]) {
                    Notify( error.data.messages[0].MESSAGE)
                }
                break;
            }
             case StatusCode.Unauthorized: {
                localStorage.clear()
                store.dispatch({ type: LoginActionTypes.UNAUTH_USER })
                store.dispatch(changeRoute(0))
                window.location.reload()
                break;
            }
            case StatusCode.TooManyRequests: {
                // Handle TooManyRequests
                if(error.data.messages[0]) {
                    Notify( error.data.messages[0].MESSAGE)
                }
                break;
            }
        }

        return Promise.reject(error);
    }
}

export const httpToken = () => {
    return axios.create({
      headers: {
          auth_token: localStorage.getItem('auth_token'),
          'Accept-Language': localStorage.getItem('preferredLanguage') === "en" ? 'en_EN' : (localStorage.getItem('preferredLanguage') === "ru" ? 'ru_RU' : 'az_AZ'),
      },
    })
  }

export const http = new Http();
